import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from '@wix/da-ds/pkg/Slider';
import StudioProductsCatalogCardA from '@wix/da-shared-react/pkg/DealerAd/Placement/StudioProductsCatalogCardA';
import StudioProductsCatalogCardB from '@wix/da-shared-react/pkg/DealerAd/Placement/StudioProductsCatalogCardB';
import StudioProductsCatalogCardC from '@wix/da-shared-react/pkg/DealerAd/Placement/StudioProductsCatalogCardC';
import StudioProductsCatalogCardD from '@wix/da-shared-react/pkg/DealerAd/Placement/StudioProductsCatalogCardD';
import StudioProductsCatalogCardE from '@wix/da-shared-react/pkg/DealerAd/Placement/StudioProductsCatalogCardE';
import StudioProductsCatalogCardF from '@wix/da-shared-react/pkg/DealerAd/Placement/StudioProductsCatalogCardF';
import s from './ExpandSalesSlider.scss';

interface Props {}

const ExpandSalesSlider: FC<Props> = () => {
  const { t } = useTranslation();
  const cardWidth = 264;

  return (
    <div className={s['root']}>
      <div className={s['title']}>{t('studio.products.expandSales.title')}</div>
      <div className={s['subtitle']}>{t('studio.products.expandSales.subtitle')}</div>
      <div className={s['slider']}>
        <Slider scrollBy={cardWidth * 6} className={s['custom-spacing']}>
          <StudioProductsCatalogCardA />
          <StudioProductsCatalogCardB />
          <StudioProductsCatalogCardC />
          <StudioProductsCatalogCardD />
          <StudioProductsCatalogCardE />
          <StudioProductsCatalogCardF />
        </Slider>
      </div>
    </div>
  );
};
ExpandSalesSlider.displayName = 'ExpandSalesSlider';

export default ExpandSalesSlider;
